/**
 * Course downloadable resources.
 */
import React, { useEffect, useState } from "react";
import { Box, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

import BEmpty from "components/BEmpty";
import { useAsterController } from "context";
import { VText } from "form";
import CourseDownloadItem from "./course.download.item";

/**
 * Lists downloadable files grouped by section.
 */
const CourseDownload = () => {
  const { t } = useTranslation("common");

  const [controller] = useAsterController();
  const { course_download } = controller;

  const [downloads, setDownloads] = useState([]);

  useEffect(() => {
    const downloads = [];
    (course_download?.sections || []).forEach((section) => {
      (section.downloads || []).forEach((download) => {
        downloads.push(download);
      });
    });
    setDownloads(downloads);
  }, [course_download]);

  return (
    <>
      <Box>
        <Box className="w-full flex justify-center sm:justify-start">
          <VText className="text-2xl font-bold">{t("Download")}</VText>
        </Box>
        {
          downloads.length ? (
            <Box className="w-full md:my-5 my-2 md:px-0 px-8">
              <Grid container spacing={3} className="md:mt-2">
                {downloads.map((download) => (
                  <Grid item xs={12} sm={6} lg={4} key={download.def_id}>
                    <CourseDownloadItem item={download} />
                  </Grid>
                ))}
              </Grid>
            </Box>
          ) :
          <BEmpty />
        }
      </Box>
    </>
  );
};

export default CourseDownload;
